import { AbstractControl, ValidatorFn, UntypedFormGroup } from '@angular/forms';

export function phoneNumberValidator(dialCode, areaCode, phoneNumber) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
        let countryCode = group.get(dialCode);
        let matches: string;
        if (countryCode && countryCode.value) {
            let areaCodeValue = group.get(areaCode).value;
            let phoneNumberValue = group.get(phoneNumber).value;

            if (countryCode.value === '1' || countryCode.value === '+1') {  //US phone number
                // validate area code
                if (areaCodeValue) {
                    matches = areaCodeValue.match(/^[0-9]{3}$/);
                    if (!matches) {
                        return { 'invalidAreaCode': true };
                    }
                }
                // validate phone number
                if (phoneNumberValue) {
                    matches = phoneNumberValue.match(/^\d{3}[-]?\d{4}$/);
                    if (!matches) {
                        return { 'invalidPhoneNumber': true };
                    }
                }
            } else { //International number
                if (areaCodeValue) {
                    let matches = areaCodeValue.match(/^[0-9-]*$/);
                    if (!matches) {
                        return { 'invalidAreaCode': true };
                    }
                }
                // validate phone number
                if (phoneNumberValue) {
                    matches = phoneNumberValue.match(/^[0-9-]*$/);
                    if (!matches) {
                        return { 'invalidPhoneNumber': true };
                    }
                }
            }
        }
    };
}
